<template>
  <VRadio
    v-bind="$attrs"
    v-on="$listeners"
    :label="_label"
    :placeholder="_placeholder"
    :rules="_rules"
  >
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />
    <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"></slot>
    </template>
  </VRadio>
</template>
<script>
const isString = v => typeof v == 'string';

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
    },
  },

  computed: {
    _label() {
      return this.$t(this.label);
    },
    _placeholder() {
      return this.$t(this.placeholder);
    },
    _rules() {
      return !this.rules
        ? []
        : this.rules.map(validation => {
            if (typeof validation == 'function')
              return text => {
                const result = validation(text);
                return isString(result) ? this.$t(result) : result;
              };
            else if (isString(validation)) return this.$t(validation);
            else return validation;
          });
    },
  },
};
</script>
